export const warrantyStatusSelector = state => state.entities.warrantyStatuses;
